import ReactPlayer from "react-player";
import { HbrCamLiveOff } from "./Mycustomsvgicons";
import { useCallback, useEffect, useRef, useState } from "react";
import { FormatTimePassedUtc } from "./GeneralClasses";

const PostLiveVideoContent = ({url,date,utcTime,liveDesc}) => {
    const [playing,setIsPlaying]=useState(false);

    const playerRef = useRef();

    const checkScroll = useCallback(() => {
      if (!playerRef.current) return;
      const rect = playerRef.current.getBoundingClientRect();
      const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;
      if (isInView) {
        setIsPlaying(true);
      }else{
        setIsPlaying(false);
      }
     
  }, []);

  useEffect(() => {
      window.addEventListener('scroll', checkScroll);
      return () => window.removeEventListener('scroll', checkScroll);
  }, [checkScroll]);

    

    return ( 
    <div className="postlivevideocontent flex-column2" ref={playerRef} onContextMenu={(e)=>e.preventDefault()}>
                {liveDesc && <h4>{liveDesc}</h4>}
        
                <div className="flex-row2" style={{
                        gap:"10px",
                        position:"absolute",
                        left:"0px",
                        top:"10px",
                        }}>
                        <div className='flex-row2'
                         style={{
                             padding:"5px",
                             gap:"3px",
                             width:"fit-content",
                             border:"none",
                             backgroundColor:"#00000050",
                             color:"white",
                             fontWeight:"bold",
                             borderRadius:"10px"}}>
                             <h4 style={{color:"white"}}>Live </h4>
                             <HbrCamLiveOff width="1em" height="1em" fillColour="#FFFFFF"/> 
                         </div>

                         <div style={{backgroundColor:"#10101050",borderRadius:"10%",padding:"5px"}}>
                            <h4 style={{color:"white"}}>{`was live ${FormatTimePassedUtc(utcTime)}`}</h4>
                         </div>

                    </div>

        <div style={{width:"100%",height:"100%"}} onClick={()=>setIsPlaying(prev => !prev)} onContextMenu={e => e.preventDefault()}>
            <ReactPlayer
            url={url}
            playing={playing}
            width="100%"
            height="100%"
            controls
            />
        </div>
    </div> 
    );
}
 
export default PostLiveVideoContent;